import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import type { Entity, EntityResponse } from "~types/entity";

const useFetchEntity = (entityId?: string) => {
  const request = useApi();
  const { organizationId, sport } = useParams();

  return useQuery<Entity>({
    queryKey: ["entity", sport, organizationId, entityId],
    queryFn: () =>
      request<EntityResponse>(`${sport}/o/${organizationId}/entities/${entityId}`).then((response) => {
        return response?.data?.[0];
      }),
    enabled: !!entityId,
  });
};

export default useFetchEntity;
